export default {
      id: "icon-dialog-usage",
      viewBox: "0 0 17 15",
      url: __webpack_public_path__ + "img/icons.svg#icon-dialog",
      toString: function () {
        return this.url;
      }
    }